import { AutoRegisterClass } from 'src/app/services/generics/classRegistry';
import { Padrao } from '../generic/padrao';
import { EndEstado } from './endEstado';

@AutoRegisterClass()
export class EndCidade extends Padrao {

    override idTab = 168;

    endEstado: EndEstado = new EndEstado();
    nome: string;
    ibge: number;
    cepGeral: number;
    ddd: string;
}
